import { DOCUMENT, isPlatformServer } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Inject, Injectable, Optional, PLATFORM_ID } from '@angular/core';
import { BrowserConfiguration, CONFIGURATION_TOKEN } from 'models';
import { BrowserConfig } from './browser-config';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ConfigService {
  constructor(  /** oggetto iniettato dal server ssr al token CONFIGUARTION_TOKEN  */
    @Optional() @Inject(CONFIGURATION_TOKEN) private config: BrowserConfiguration,
    @Inject(PLATFORM_ID) private platformID: any,
    @Optional() @Inject(DOCUMENT) private document: Document,
    private http: HttpClient) { }

  getConfigByHTTP() {
    return new Promise<BrowserConfiguration>((resolve) => {
      const baseUri = !environment.production ? 'assets' : this.document.baseURI;
      this.http.get<BrowserConfiguration>(`${baseUri}/config.json`.replace('//comparatore-config', '/comparatore-config')).subscribe((data: BrowserConfiguration) => resolve(data))
    })
  }

  static setConfigFromObj(obj: BrowserConfiguration) {
    for (let k in obj)
      //@ts-ignore
      BrowserConfig[k] = obj[k]
    BrowserConfig.loaded = true;
  }

  set(): Promise<true> {
    return new Promise((resolve) => {
      // se è il server valorizza l'oggetto static ConfigurationBrowser con l'oggetto config iniettato
      if (isPlatformServer(this.platformID)) {
        ConfigService.setConfigFromObj(this.config)
        return resolve(true);
      } else if (window && 'ComparatoreMFParameters' in window && window['ComparatoreMFParameters']) {
        ConfigService.setConfigFromObj(window.ComparatoreMFParameters as BrowserConfiguration)
        return resolve(true);
      } else {
        // altrimenti fa una richiesta http che gli restituisca il json di confugrazione
        this.getConfigByHTTP().then(data => {
          ConfigService.setConfigFromObj(data)
          return resolve(true);
        })
      }
    });
  }
}
